<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-end">
        <v-flex xs12>
          <h3 class="text-center">TIKO Request</h3>
        </v-flex>
        <v-flex xs12 md6 sm6>
          <v-card>
            <v-card-text>
              <show-tiko :tiko_request="tiko_request"></show-tiko>
            </v-card-text>
            <v-card-actions class="py-1">
              <v-spacer></v-spacer>
              <v-btn small outlined text @click="createVisit = !createVisit" title="Take vitals" :loading="visiting">Vitals</v-btn>
              <v-btn small text outlined v-if="tiko_request.request" @click="goTo('/service_requests/' + tiko_request.request.id)" color="lime">View Request</v-btn>
              <v-btn small text title="Edit details" color="orange" v-if="canEdit" @click="goTo('/tiko_requests/' + tiko_request.id + '/edit')" outlined>
                <v-icon left>mdi-content-save-edit-outline</v-icon>Edit
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 md6 sm6>
          <v-card>
            <v-card-title class="py-0">
              <v-spacer></v-spacer>
              Vitals
            </v-card-title>
            <v-card-text>
              <v-data-table :items="visits" :headers="headers" dense :items-per-page="5" :sort-by="['date']" :sort-desc="[true]" multi-sort>
                <template v-slot:item="{ item }">
                  <tr @click="goTo('/clients/' + client.id + '/visits/' + item.id)">
                    <td>{{ item.date }}</td>
                    <td>{{ item.user.name }}</td>
                    <td>
                      <inertia-link :href="'/clients/' + client.id + '/visits/' + item.id">View</inertia-link>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <mk-dialog v-model="createVisit" heading="Create Vitals">
        <form @submit.prevent="saveVisit" class="ma-2">
          <v-text-field label="Date" v-model="visit.date" type="date" required="required"></v-text-field>
          <v-btn small type="submit" color="primary" class="pull-right" :loading="visit.processing">Save</v-btn><br>
        </form>
      </mk-dialog>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const MkDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/mk-dialog')
  const ShowTiko = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "tiko-requests" */ '@/Components/Tiko/show')

  export default {
    name: 'ViewTIKORequest',
    layout,
    props: [
      'tiko_request', 'canEdit'
    ],
    components: {
      ShowTiko,
      MkDialog,
    },
    metaInfo () {
      return {
        title: 'TIKO Request',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        visiting: false,
        headers: [
          {
            text: 'Date', value: 'date'
          },
          {
            text: 'User/Professional', value: 'user_name'
          },
          {
            text: '', value: 'link', sortable: false
          }
        ],
        createVisit: false,
        visit: this.$inertia.form({
          date: this.moment().format('yyyy-MM-DD')
        })
      }
    },
    methods: {
      saveVisit () {
        this.visiting = true
        this.visit.post('/tiko_requests/' + this.tiko_request.id + '/visits', {
          onFinish: () => {
            this.visiting = false;
           },
           onSuccess: () => {
             this.createVisit = false
           }
        })
      }
    },
    computed: {
      client () {
        return this.tiko_request.client
      },
      visits () {
        return this.tiko_request.visits
      },
    }
  }
</script>

<style>
   /**/
</style>
